import React, { useEffect, useState } from 'react';

import {
  Tr,
  Td,
  TdPrice,
  PriceContent,
  LabelWrapper,
  PriceWrapper,
  ButtonWrapper,
  SVGWrapper,
  InputWrapper,
  InputContainer,
  RequiredLabel,
} from './css';
import EditSVG from '../assets/svg/edit';
import CancelSVG from '../assets/svg/cancel';
import SaveSVG from '../assets/svg/save';
import {
  changeFee,
  saveFee,
} from './saveSchemaToDB';

const Fee = ({ setSavingData, offeringId, feeData, setFeeData }) => {
  const { name, id, amount } = feeData;
  const [feeName, setFeeName] = useState(name);
  const [feeAmount, setFeeAmount] = useState(amount);
  const [editMode, setEditMode] = useState(false);
  useEffect(() => {
    setFeeName(feeData.name);
    setFeeAmount(feeData.amount);
  }, [feeData]); 

  const handleCancel = () => {
    setFeeName(name);
    setFeeAmount(amount);
    setEditMode(false);
  };

  const handleSave = async () => {
    if(!feeName.trim()) return;
    const clonedFeeData = JSON.parse(JSON.stringify(feeData));

    try {
      setSavingData(true);
      if (id) {
        if(feeName.trim())
        {

            await changeFee({
              id,
              name: feeName,
              amount: feeAmount,
              offeringId
            });
            clonedFeeData.name = feeName;
            clonedFeeData.amount = feeAmount;
        }
      } else if (feeName.trim()) {

            const newFee = await saveFee({
              offeringId,
              amount: feeAmount,
              name: feeName
            });
            
            clonedFeeData.id = newFee;
            clonedFeeData.name = feeName;
            clonedFeeData.amount = feeAmount;
      }
      setFeeData(clonedFeeData);
    } catch {
      console.log('An error occurred while saving data');
      setSavingData(false);
    } finally {
      setEditMode(false);
      setSavingData(false);
    }
  };
  return (
    <Tr>
      <Td background="#f7f7f7">
        <LabelWrapper>
          {editMode ? (
            <InputWrapper>
              <InputContainer>
                <input
                  type="text"
                  style={{
                    width: '330px',
                    borderColor: feeName ? '#e4e4e4' : '#C12335'
                  }}
                  value={feeName}
                  onChange={e => setFeeName(e.target.value)}
                />
                {!feeName.trim() && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
            </InputWrapper>
          ) : (
            <span>{name || '[Fee label not added]'}</span>
          )}

          <ButtonWrapper>
            {editMode ? (
              <>
                <SVGWrapper onClick={handleCancel}>
                  <CancelSVG />
                </SVGWrapper>
                <SVGWrapper onClick={handleSave}>
                  <SaveSVG />
                </SVGWrapper>
              </>
            ) : (
              <SVGWrapper onClick={() => setEditMode(!editMode)}>
                <EditSVG />
              </SVGWrapper>
            )}
          </ButtonWrapper>
        </LabelWrapper>
      </Td>
      <Td>
        <input type="text" value="" placeholder={feeName} disabled />
      </Td>
      {editMode ? (
        <>
          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <input
                  type="text"
                  value={`${feeAmount}`}
                  style={{
                    borderColor: feeAmount ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setFeeAmount(e.target.value)}
                />
                {!feeAmount && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
            </InputWrapper>
          </TdPrice>
        </>
      ) : (
        <>
          <Td>
            {amount ? (
              <>
                <PriceWrapper>
                  <PriceContent>{`$${amount}`}</PriceContent>
                </PriceWrapper>
              </>
            ) : (
              '-'
            )}
          </Td>
        </>
      )}
    </Tr>
  );
};

export default Fee;
